import { useEffect } from "react";
import { useSearchParams, } from "react-router-dom";
import '../styles/character.scss'

const CharacterData = [
    {
        name: 'Étrange von Rosenburg',
        badgeName: 'Étrange',
        image: 'etrange',
        title: 'Wicked Villainess with One Hell of a Sweet Tooth',
        description: <>
            Daughter of the late duke and duchess of House Rosenburg. Condemned and executed as a villainess of the highest order, she winds up in hell following her death. Yet with her mastery of the dark arts and overwhelming charisma, she gains allies and grows more formidable with each passing day.<br/><br/>
            While she always remains true to her herself and her convictions, she also possesses a girlish side—which often presents itself in the form of her rabid obsession with sweets.
        </>,
        quote: "I shall aim to live the happiest life possible here in hell! And I will relish in it!"
    },
    {
        name: 'Cat-Smìth',
        image: 'cat-smith',
        title: 'Charming Pet and Dependable Partner',
        description: <>
            Étrange's beloved cat from her previous life, with whom she reunites in hell. Despite his cute appearance, Cat-Smìth is a veritable terror on the battlefield, where his ferocious side comes out to play. He remains unerringly faithful to his mistress, proving his worth as a stalwart ally.
        </>,
        quote: "Mrowr."
    },
    {
        name: 'Cackie',
        image: 'cackie',
        title: 'Handsome Butler and Dual Blades Master',
        description: <>
            A former demon, now transformed into a gorgeous butler with deep sea-blue eyes and long, flowing golden hair. He serves as Étrange's right hand and supports her from the sidelines. Delicate in manner, he has a way of soothing others with his complimentary tone—truly the ideal butler.
        </>,
        quote: "We vow to serve you—mind, body, and soul—from now to eternity, Master."
    },
    {
        name: 'Chuckie',
        image: 'chuckie',
        title: 'Mighty Warrior Bearing an Iron Physique',
        description: <>
            A former demon, now transformed into a dignified warrior with an impressive beard that speaks to his years of experience in battle. With his overwhelming strength and endurance, he acts as a bulwark on the front lines to shield Étrange from any harm. Loyal to a fault, his devotion to his master is unbreakable.
        </>,
        quote: "As your lackey, what you did means a lot. Your love for us runs deeper than even the bowels of hell itself!"
    },
    {
        name: 'Chortie',
        image: 'chortie',
        title: 'Unhinged Quipster',
        description: <>
            A former demon, now transformed into an adorable child with bounce-off-the-walls energy. Their bright, innocent personality fills any room they walk in with positive vibes, lifting the spirits of everyone around them. They also have an oddly idiosyncratic laugh... Hyaha!
        </>,
        quote: "We really ARE unstoppable! A grand army of hell to end all grand armies of hell!"
    },
    {
        name: 'Sweetia',
        image: 'sweetia',
        title: 'Tenacious Maid with Cream-of-the-Crop Pâtissier Skills',
        description: <>
            Étrange's personal maid, with whom she has reunited in hell. Sweetia excels at making confections and is positively beaming with kindness and devotion. On the other hand, she is surprisingly courageous in the face of adversity, favoring a combat style that involves beating her opponents into submission with a series of brutal slaps.
        </>,
        quote: "Nothing would please me more than to be of service to my lady—even in hell."
    },
    {
        name: 'Erit',
        image: 'erit',
        title: 'Highbrow Demon Presiding Over Hell\'s Floggings',
        description: <>
            A noble count wielding a high-grade spiked leather whip and a former overseer of the floggings in hell. Though once feared far and wide, he swore allegiance to Étrange after his defeat and now takes great pleasure in his role as her strategist.
        </>,
        quote: "As the one charged with flogging wayward ne'er-do-wells, there's no person better suited to the task of cleansing them of their sins and impurities."
    },
    {
        name: 'Schwartz',
        image: 'schwartz',
        title: 'Skilled Mercenary with an Encyclopedic Knowledge of Weaponry',
        description: <>
            A profoundly-competent soldier who once led his own mercenary unit. Despite repeatedly boasting of his unparalleled combat prowess, he was humbled after losing to Étrange and vowed to devote himself to her service. Since then, he's begun addressing her as "ma'am" and shows her nothing but the utmost respect. He is also highly skilled in weapon maintenance.
        </>,
        quote: "Anyway, you, li'l lady, are the most powerful, sinister, and terrifying human weapon I've ever come across. Think I'll call you \"ma'am\" from now on."
    },
    {
        name: 'Ignacio',
        image: 'ignacio',
        title: 'Child Prodigy and Inventor',
        description: <>
            A young inventor with a genius-level intellect who runs the largest firearms manufacturing company in hell. His cerebral gifts have helped him created many revolutionary new weapons. Despite being burdened by a traumatic past, his encounter with Étrange has done much to brighten his disposition.
        </>,
        quote: "And if you lose...you have to become my mother!"
    },
    {
        name: 'Kera',
        image: 'kera',
        title: 'Affable Eldest Beast Sister',
        description: <>
            The oldest sister of the beast triplets, Kera is naturally sociable; her likeable personality makes breaking the ice with anyone a cinch. Her sole weakness is her all-consuming craving for sweets. Evidently, she was also once one of Overlord Doomaz's retainers.
        </>,
        quote: "You're gonna spend the rest of your lives paying for what you did! No more 3PM snack times! PERIOD!"
    },
    {
        name: 'Bera',
        image: 'bera',
        title: 'Princely Middle Beast Sister',
        description: <>
            The middle child of the beast triplets, Bera is a cool, detached beauty who keeps her emotions hidden beneath the surface—though when presented with sweets, her heart races like mad. Evidently, she was also once one of Overlord Doomaz's retainers.
        </>,
        quote: "Nice one, Kera. No one dishes out punishments like you!"
    },
    {
        name: 'Rosa',
        image: 'rosa',
        title: 'Naive Youngest Beast Sister',
        description: <>
            The baby of the beastkin sister family, Rosa is naive and happy-go-lucky. Having been spoiled rotten by her sisters, she makes no secret of her massive sweet tooth.
        </>,
        quote: "Suddenly, I'm REALLY glad Kera's on our side!"
    },
    {
        name: 'Aria',
        image: 'aria',
        title: 'Sole Daughter of the Venerable Succubus Queen',
        description: <>
            Princess of the succubi and only child of Queen Aliceandros. Accompanied by her personal guards, she approaches Étrange with a declaration of war. Although her demeanor is as prideful as one would expect for someone of her station, she, for reasons unknown, has a fierce aversion to sweets.
        </>,
        quote: "That's why I intend to wipe sweets off the face of this world! Once and for all!"
    },
    {
        name: 'Overlord Doomaz',
        image: 'overlord-doomaz',
        badgeName: <>
            <span className="gold-gradient">Overlord</span> <br/><span className="gold-gradient">Doomaz</span>
        </>,
        title: 'Current Overlord of Hell Turned Obsessed Gamer',
        description: <>
            Doomaz may be the absolute ruler and overlord of hell, but he has let much of his duties fall by the wayside of late. Why? Because of his hobby-turned-obsession with playing and creating video games, of course! As a consequence of his recent actions, however, his demonic subordinates have been left utterly baffled and now consider him a lost cause.
        </>,
        quote: "Very well, then. If it's death you seek, then I'll humbly grant it to you—personally!"
    },
    {
        name: 'Jewel',
        image: 'jewel',
        title: 'Loyal Butler Who Vows to Seek the Truth',
        description: <>
            A highly-intelligent butler who has served Étrange since her youth. Driven to avenge his master after her execution, he continues on alone in his dogged pursuit of the truth.
        </>,
        quote: "I will find evidence of your innocence—whatever the cost."
    },
    {
        name: 'The Crown Prince',
        image: 'crown-prince',
        badgeName: 'Crown Prince',
        title: 'Crown Prince and Étrange\'s Former Betrothed',
        description: <>
            The prince of Edelstein Kingdom, renowned for his strikingly handsome appearance and immense popularity among his people. He is also the very person who sentenced Étrange, his former fiancée, to death.
        </>,
        quote: "My engagement to that living weapon was annulled, and now you and I are to be wed, Angelina."
    },
    {
        name: 'Angelina',
        image: 'angelina',
        title: 'The "True Heroine" After Étrange\'s Death',
        description: <>
            The future queen who forged a new marriage pact with the crown prince following Étrange's death. By winning the prince's favor, she has become the successor to the Rosenburg family and presents herself as an ideal partner for the prince. However, something else lurks unseen behind her innocent smile...
        </>,
        quote: "Even so, it pains me greatly that I cannot share this happiness with her..."
    }
]

const Character = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const characterImage = searchParams.get('char');

    useEffect(() => {
        if (!searchParams.get('char')) {
            setSearchParams({ char: 'etrange' });
        }
    }, [searchParams, setSearchParams]);

    const currentCharacterIndex = CharacterData.findIndex(
        (char) => char.image === characterImage
    );
    
    const character = CharacterData[currentCharacterIndex];

    const handleNext = () => {
        const nextIndex = (currentCharacterIndex + 1) % CharacterData.length;
        const nextCharacter = CharacterData[nextIndex];
        
        setSearchParams({ char: nextCharacter.image });
    };

    const handlePrevious = () => {
        const prevIndex = (currentCharacterIndex - 1 + CharacterData.length) % CharacterData.length;
        const prevCharacter = CharacterData[prevIndex];
        
        setSearchParams({ char: prevCharacter.image });
    };

    if (!character) {
        return null;
    }

    return (
        <div className='page-container character-bg'
            style={{paddingTop: "100px"}}
        >
            <div className="title-wrapper">
                <div className="title-character">
                    <img src={`${process.env.PUBLIC_URL}/img/ttl_chara01.png`} alt="" />
                </div>
                <img src={`${process.env.PUBLIC_URL}/img/ttl_character.png`} alt="" className="image-title" />
            </div>
            <div id="char-top"></div>
            <div className="frame"
                style={{
                    position: 'relative'
                }}
            >
                <div className="character-nav">
                    <button className="character-nav_prev"
                        onClick={()=>handlePrevious()}
                    >
                        <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="prev"/>
                    </button>
                    <button className="character-nav_next"
                        onClick={()=>handleNext()}    
                    >
                        <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="next"/>
                    </button>
                </div>
                <section className="character-body">
                    <div className="character-left">
                        <div className="mobile-name">
                            <h2 className="character-title">
                                {
                                    character.title
                                }
                            </h2>
                            <h1 className="character-name gold-gradient">
                                {
                                    character.name
                                }
                            </h1>
                        </div>
                        <img 
                            src={`${process.env.PUBLIC_URL}/img/character/chara_img${
                                currentCharacterIndex+1 < 10 ? `0${currentCharacterIndex+1}` : currentCharacterIndex+1
                            }.png`} 
                            alt={`${character.name} Key Art`} 
                            className="character-keyart" 
                        />
                        <h3 className="character-quote">
                            <span className="gold-gradient">
                                "{
                                    character.quote
                                }"
                            </span>
                        </h3>
                    </div>
                    <div className="character-right">
                        <h2 className="character-title">
                            {
                                character.title
                            }
                        </h2>
                        <h1 className="character-name gold-gradient">
                            {
                                character.name
                            }
                        </h1>
                        <div className="character-divider"></div>
                        <p className="character-description">
                            {
                                character.description
                            }
                        </p>
                        <div className="character-ss">
                            <img 
                                src={`${process.env.PUBLIC_URL}/img/character/chara_still${
                                    currentCharacterIndex+1 < 10 ? `0${currentCharacterIndex+1}` : currentCharacterIndex+1
                                }.png`} 
                                alt={`${character.name} Screenshot`}
                            />
                        </div>
                    </div>
                </section>
                <div className="character-list">
                    {
                        CharacterData.map((char, i)=>(
                            <a href="#char-top">
                                <div className="character-badge"
                                    onClick={()=>{
                                        setSearchParams({ char: char.image });
                                    }}
                                >
                                    <h3 className='gold-gradient'>{char.badgeName ? char.badgeName : char.name }</h3>
                                    <img src={`${process.env.PUBLIC_URL}/img/character/${char.image}.webp`} alt="" className="character-icon" />
                                </div>
                            </a>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Character;
